const HTML_ESCAPES: Record<string, string> = {
  '&': '&amp;',
  '<': '&lt;',
  '>': '&gt;',
  '"': '&quot;',
  "'": '&#39;',
}

/**
 * Экранирует HTML в тексте, который потом подставляется через `v-html`.
 *
 * Нужен там, где разметку мы добавляем сами (жирный, курсив, переносы), а исходный текст
 * пришёл от пользователя или из настроек. Без экранирования такой текст выполняется как
 * разметка: шаблон уведомления с `<img src=x onerror=...>` — это кража токена админки
 * из localStorage у того, кто просто открыл страницу настроек.
 *
 * Замена идёт одним проходом по строке, посимвольно, поэтому вставленные
 * последовательности повторно не обрабатываются: `&lt;` превращается в `&amp;lt;`,
 * а не в `&amp;amp;lt;`.
 */
export function escapeHtml(value: string): string {
  return value.replaceAll(/["&'<>]/g, (char) => HTML_ESCAPES[char] ?? char)
}
